import { convertToMapById } from "helpers/convertToMap";
import { convertToObjById } from "helpers/convertToObject";

export const PRODUCT_SELECTED = 'PRODUCT_SELECTED';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const MOD_PRODUCT = 'MOD_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const RESET_PRODUCT_SELECTED = 'RESET_PRODUCT_SELECTED';
export const ADD_PRODUCT_MODE = 'ADD_PRODUCT_MODE';
export const EDIT_PRODUCT_MODE = 'EDIT_PRODUCT_MODE';
export const CHECK_ADD_PRODUCT_MODE_PERMIT = "CHECK_ADD_PRODUCT_MODE_PERMIT"
export const DELETE_PRODUCT_MODE = "DELETE_PRODUCT_MODE"

const initialState = {
  products: {},
  productsArr: [],
  productSelected: null,
  addProduct: true,
  addMode: false,
}

export const productsCatalogReducer = (state = initialState, action) => {

  switch (action.type) {

    case ADD_PRODUCT_MODE:
      return {
        ...state,
        addMode: true,
        deleteMode: false
      }

    case EDIT_PRODUCT_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false
      }

    case DELETE_PRODUCT_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      }
    
    case CHECK_ADD_PRODUCT_MODE_PERMIT:
      return {
        ...state,
        addProduct: action.payload,
      }

    case GET_PRODUCTS:
      const filteredProducts = action.payload.filter(product => product?.name.length > 0);
      const listProducts = convertToObjById(filteredProducts);
      return {
        ...state,
        products: listProducts,
        productsArr: filteredProducts,
      }

    case PRODUCT_SELECTED:
      return {
        ...state,
        productSelected: action.payload && state.products[action.payload]
      }
      
    case RESET_PRODUCT_SELECTED:
      return {
        ...state,
        productSelected: null
      }

    case CREATE_PRODUCT:
      const addingProduct = [action.payload, ...convertToMapById(state.products) ]
      const newProducts = convertToObjById(addingProduct)
      return {
        ...state,
        products: newProducts,
        productsArr: addingProduct,
      }

    case MOD_PRODUCT:
      return {
        ...state,
        products: {
          ...state.products,
          [action.payload.id]: {
            ...state.products[action.payload.id],
            ...action.payload
          },
        },
      }

    case DELETE_PRODUCT:
      const dataArray = convertToMapById(state.products).filter(product => product.id !== action.payload)
      const productsWithOutDeletedProduct = convertToObjById(dataArray)
      return {
        ...state,
        products: productsWithOutDeletedProduct,
        productsArr: dataArray,
      }

    default :
      return state
  }
}